import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const CaramelDealStatusBadge = ({ dealStatus, isPrivateListing = false }) => (
  <div
    className={classnames('pos-r bg-yellow-60 text-cool-gray-10')}
    style={{
      position: 'absolute',
      fontSize: '1rem',
      fontWeight: 'bold',
      textAlign: 'center',
      lineHeight: '1.75rem',
      minWidth: '240px',
      padding: '4px 0',
      transform: 'rotate(-30.989deg)',
      right: '-27px',
      bottom: '28px',
    }}
  >
    {dealStatus}
    {isPrivateListing && <i className="icon-info size-10 ms-0_25" aria-hidden />}
  </div>
);
CaramelDealStatusBadge.propTypes = {
  dealStatus: PropTypes.string.isRequired,
  isPrivateListing: PropTypes.bool,
};
